import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {BankverbindungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-lib-bankverbindung-angaben',
  templateUrl: './bankverbindung-angaben.component.html'
})
export class BankverbindungAngabenComponent extends WizardPageBaseComponent<BankverbindungAngaben> {

  static nutzdatenPath = 'bankverbindungAngaben';
  static route = 'bankverbindung-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  public clearBankInformation($event: boolean): void {
    if (!$event) {
      this.data.bankverbindungBetriebssteuern = null;
    }
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([
      ['bankverbindungPersonensteuern', this.stammdaten?.antragsteller?.bankverbindungen],
      ['bankverbindungBetriebssteuern', this.stammdaten?.unternehmen?.bankverbindungen]
    ]);
  }
}
